var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.966 18c-.582 0-1.081-.22-1.414-.588L2.321 9.255c-.5-.588-.416-1.47.25-1.911.664-.44 1.579-.44 2.078.147l7.15 7.202c.084.073.167.073.333 0l7.15-7.202a1.623 1.623 0 0 1 2.163-.147c.665.514.748 1.323.166 1.91l-.083.074-8.149 8.157c-.332.294-.914.515-1.413.515"
  })));
};
export default SvgChevronDown;